import { render, staticRenderFns } from "./shopRemoverec.vue?vue&type=template&id=5520ebe7&scoped=true&"
import script from "./shopRemoverec.vue?vue&type=script&lang=js&"
export * from "./shopRemoverec.vue?vue&type=script&lang=js&"
import style0 from "./shopRemoverec.vue?vue&type=style&index=0&id=5520ebe7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5520ebe7",
  null
  
)

export default component.exports